export default function normalizeProviders(data) {
    if (!data) return null;

    return {
        apiKeys: data.apiKeys,
        id: data.id,
        name: data.name,
    };
}
